import { styled } from '@mui/material/styles';

export const TextWithEllipsis = styled('div')`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
